import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import M from "@/libs/mapping.js";
import { AUTH_SERVICE } from "@/datas/authservice";

Vue.use(Vuex);

/**
 * 화면 갱신시 토큰 셋팅 test 코드
 */
// const enhanceAccessToeken = () => {
//   const accessToken = localStorage.getItem("accessToken");
//   if (!accessToken) return;
//   axios.defaults.headers.common["Authorization"] = accessToken;
// };
// enhanceAccessToeken();

/**
 * store
 */
export default new Vuex.Store({
  state: {
    mode: null,
    expires_at: null,
    point: null,
    accessToken: null,
    refreshToken: null,
    mallId: null,
    shopNo: null,
    appCode: null,
    mallType: null,
    entries: null,
    siteCode: null,
    is_set_unitCode: false,
    progressDisplay: false,
    alert: {
      display: false,
      msg: "",
    },
    circularProgress: {
      html: "",
      display: false,
      value: 0,
    },
    shopUserId: null, // imweb 사용자 아이디 (imweb 전용)
    isRefreshingToken: false, // 토큰 갱신 중 플래그 추가
  },
  getters: {},
  mutations: {
    SET_SHOP_ID(state, shop_id) {
      state.shopUserId = shop_id;
    },
    SET_ENTRIES(state, entires) {
      state.entries = entires;
    },
    SET_APP_CODE(state, app_code) {
      state.appCode = app_code;
      sessionStorage[`shoplus_cert_appCode`] = app_code;
    },
    SET_MALL_ID(state, mall_id) {
      state.mallId = mall_id;
      sessionStorage["current_mall_id"] = mall_id;
    },
    SET_SITE_CODE(state, site_code) {
      state.siteCode = site_code;
    },
    SET_IS_SET_UNIT_CODE(state, is_set_unitCode) {
      state.is_set_unitCode = is_set_unitCode;
    },
    /**
     * 토큰 저장
     * @param {*} state
     * @param {*} accessToken
     */
    REFRESH_ACCESS_TOKEN(state, accessToken) {
      state.accessToken = accessToken;
      // 토큰을 로컬 스토리지에 저장
      // console.log("set localstorage accessToken", accessToken);
      localStorage.setItem(`${state.appCode}_${state.mallId}_accessToken`, accessToken);
      localStorage.setItem(`${state.mallId}_accessTime`, new Date().toLocaleString("ko-KR", { timeZone: "Asia/Seoul" }));
      localStorage.setItem(`${state.mallType}_cert_access_token`, accessToken);
    },
    CHANGE_VERSION(state, version) {
      state.mode = version;
    },
    CHANGE_SHOPNO(state, shopNo) {
      state.shopNo = shopNo;
      localStorage.setItem(`${state.appCode}_${state.mallId}_shop_no`, shopNo);
    },
    SET_VERSION(state, payload) {
      if (payload.class === null) {
        state.mode = AUTH_SERVICE.APP_MODE.ANY;
        state.point = 0;
        state.expires_at = null;
      } else {
        state.mode = payload.class;
        state.point = payload.remain_point ?? 0;
        state.expires_at = payload.expires_at;
      }
    },
    SET_MALL_TYPE(state, mallType) {
      if (!mallType || mallType === "null" || mallType === "undefined") {
        mallType = "mall"; // 기본값 설정
      }
      state.mallType = mallType;
      sessionStorage[`shoplus_cert_mallType`] = mallType;
    },
    SET_SHOPLUS_ACCESS_TOKEN(state, accessToken) {
      state.accessToken = accessToken;
      sessionStorage.shoplusAuthServiceAccessToken = accessToken;
    },
    SET_SHOPLUS_REFRESH_TOKEN(state, refreshToken) {
      state.refreshToken = refreshToken;
    },
    /**
     * 포인트 업데이트
     * @param {*} state
     * @param {*} point - 새로운 포인트 값
     */
    UPDATE_POINT(state, point) {
      state.point = point ?? 0;
    },
    /**
     * 토큰 갱신 상태 설정
     * @param {*} state
     * @param {*} isRefreshing - 토큰 갱신 중 여부
     */
    SET_REFRESHING_TOKEN(state, isRefreshing) {
      state.isRefreshingToken = isRefreshing;
    },
  },
  actions: {
    SET_SHOP_ID({ commit }, data) {
      commit("SET_SHOP_ID", data);
    },
    SET_MALL_ID({ commit }, data) {
      commit("SET_MALL_ID", data);
    },
    SET_ACCESS_TOKEN({ commit }, data) {
      // console.log("set state accessToken", data);
      commit("REFRESH_ACCESS_TOKEN", data.access_token);
      if (this.state.mallType === "imweb") {
        axios.defaults.headers.common["Authorization"] = `Bearer ${data.access_token}`;
      } else {
        axios.defaults.headers.common["Authorization"] = data.access_token;
      }
    },
    /**
     * 토큰인증 refresh - 무한루프 방지 로직 추가
     * @param {*} param0
     */
    async REFRESH_ACCESS_TOKEN({ commit, state }) {
      // 이미 토큰 갱신 중인 경우 에러 발생시켜 무한루프 방지
      if (state.isRefreshingToken) {
        console.warn("Token refresh already in progress, preventing infinite loop");
        throw new Error("Token refresh already in progress");
      }

      commit("SET_REFRESHING_TOKEN", true);

      try {
        let data;
        if (this.state.mallType === "imweb") {
          // Imweb 전용 처리
          const refresh_token = localStorage.getItem("imweb_cert_refresh_token");
          axios.defaults.headers.common["Authorization"] = `Bearer ${refresh_token}`;
          if (refresh_token) {
            data = await M.api(M.entry("/post/member/refresh"), { refresh_token });
            if (data.status && data.status === "404") {
              throw new Error("refreshError: Invalid refresh_token");
            }
          } else {
            throw new Error("refreshError: refresh_token is missing");
          }
        } else {
          data = await M.api(M.entry("/auth/refresh"));
        }

        if (data.access_token) {
          commit("REFRESH_ACCESS_TOKEN", data.access_token);
          if (this.state.mallType === "imweb") {
            axios.defaults.headers.common["Authorization"] = `Bearer ${data.access_token}`;
            if (data.refresh_token) {
              localStorage.setItem("imweb_cert_refresh_token", data.refresh_token);
            }
          } else {
            axios.defaults.headers.common["Authorization"] = data.access_token;
          }
        } else {
          throw new Error("No access_token received from refresh API");
        }
      } catch (error) {
        console.error("Token refresh failed:", error);
        // 토큰 갱신 실패 시 상태 초기화
        commit("REFRESH_ACCESS_TOKEN", null);
        throw error;
      } finally {
        // 성공/실패 관계없이 플래그 해제
        commit("SET_REFRESHING_TOKEN", false);
      }
    },
    CHANGE_SHOPNO({ commit }, shop_no) {
      if (this.state.mallType == "imweb") {
        if (shop_no) {
          if (!this.state.is_set_unitCode) {
            commit("SET_SITE_CODE", this.state.mallId);
            commit("SET_IS_SET_UNIT_CODE", true);
          } else {
            //g  commit("SET_MALL_ID", shop_no);
          }
          commit("CHANGE_SHOPNO", shop_no);
        }
      } else {
        if (shop_no) {
          commit("CHANGE_SHOPNO", shop_no);
        }
      }
    },
    CHANGE_VERSION({ commit }, version) {
      if (version) {
        commit("CHANGE_VERSION", version);
      }
    },
    async SET_CERT_PRODUCTS_VERSION({ commit }) {
      //console.log("store set version check");
      try {
        let data = await M.api(M.entry("/cert/products/class"));
        if (Object.prototype.hasOwnProperty.call(data, "class")) {
          commit("SET_VERSION", data);
        }
      } catch (e) {
        if (e.response.status !== 401) {
          commit("SET_VERSION", { class: null });
        }
      }
    },
    async SET_MALL_TYPE({ commit }, mallType) {
      commit("SET_MALL_TYPE", mallType);
    },
    async SET_SHOPLUS_ACCESS_TOKEN({ commit }, accessToken) {
      commit("SET_SHOPLUS_ACCESS_TOKEN", accessToken);
      axios.defaults.headers.common["Authorization"] = accessToken;
    },
    async SET_SHOPLUS_REFRESH_TOKEN({ commit }, refreshToken) {
      commit("SET_SHOPLUS_REFRESH_TOKEN", refreshToken);
    },
    async SET_SHOPLUE_ACCESS_REFRESH_TOKEN({ commit }, refreshToken) {
      let data = await M.api(M.entry("/shoplus/auth/refresh"), {
        refresh_token: refreshToken,
      });
      commit("SET_SHOPLUS_ACCESS_TOKEN", data.access_token);
      if (this.state.mallType === "imweb") {
        axios.defaults.headers.common["Authorization"] = `Bearer ${data.access_token}`;
      } else {
        axios.defaults.headers.common["Authorization"] = data.access_token;
      }
    },
  },
});
